document.addEventListener('variant:add', function(event) {
  let productInfoBlockList = event.target.closest('.product-info__block-list');
  let productInfoQty = productInfoBlockList.querySelector('[data-block-type="buy-buttons"] quantity-input input')
  let productInfoGiftWrap = productInfoBlockList.querySelector('[data-block-type="gift-wrap"] [name*="properties"]');
  let productInfoGiftWrapVariant = productInfoBlockList.querySelector('[data-block-type="gift-wrap"] #gift-wrap-variant');
  let productInfoGift = productInfoBlockList.querySelector('[data-block-type="gift"] [name*="properties"]');
  let productInfoGiftVariant = productInfoBlockList.querySelector('[data-block-type="gift"] #gift-variant');
  
  if(productInfoGift){
    if(productInfoGift.checked) {
      const formData = {
      'items': [
        {
          'id': productInfoGiftVariant.value,
          'parent_line_key': event.detail.items[0].key,
          'quantity': productInfoQty.value
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          return response.json();
          setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          }, 200); 
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
  
  if(productInfoGiftWrap) {
    if(productInfoGiftWrap.checked) {
      const formData = {
      'items': [
        {
          'id': productInfoGiftWrapVariant.value,
          'parent_line_key': event.detail.items[0].key,
          'quantity': productInfoQty.value
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          return response.json();
          setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          }, 200); 
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
  
});

document.addEventListener('cart:change', function(event) {
  let cartItems = event.detail.cart.items;
  if (event.detail.baseEvent == 'line-item:change') {
    console.log(event.detail.cart);
    let addedItem = event.detail.cart.items_added[0];
    let removedItem = event.detail.cart.items_removed[0];

    if (addedItem) {
      cartItems.forEach((item, index) => {
        let itemParentRelationship = item.parent_relationship;
        if (itemParentRelationship && itemParentRelationship.parent_key == addedItem.view_key) {
          const formData = {
            'id': item.key,
            'quantity': item.quantity + addedItem.quantity
          };

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
            .then(response => {
              return response.json();
              setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              }, 200); 
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      });
    } else if (removedItem) {
      cartItems.forEach((item, index) => {
        let itemParentRelationship = item.parent_relationship;
        if (itemParentRelationship && itemParentRelationship.parent_key == removedItem.view_key) {
          const formData = {
            'id': item.key,
            'quantity': item.quantity - removedItem.quantity
          };

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
            .then(response => {
              return response.json();
              setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              }, 200); 
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      });
    }
  }
});